module.exports = __webpack_public_path__ + "img/se.58ad56c5.svg";